<template>
  <div class="mediaToggle">
    <label v-if="label" for="image">{{ text }}</label>
    <div v-if="media">
      <img :src="media.images.slider_thumb" :alt="media.alt" v-if="media.images">
      <div class="mediaToggle__file" v-else>
        {{ media.file_name }}
      </div>
      <br />
      <button type="button" @click="removeMedia" class="btn btn--primary btn--small">Remove</button>
    </div>
    <div class="mediaToggle__inner" v-else>
      <p><font-awesome-icon :icon="['fal', 'image']" /> <br /><strong>Choose</strong> an image</p>
      <a @click="toggleMediaUploader()" class="mediaToggle__button">Choose image</a>
    </div>

    <MediaUploader v-if="showMediaUploader" @closeMediaUploader="toggleMediaUploader()" :canSelectFiles="canSelectFiles" :media.sync="media"/>
  </div>
</template>

<script>
import MediaUploader from './MediaUploader'
export default {
  components: { MediaUploader },
  props: {
    label: {
      default: true
    },
    text: {
      default: 'Featured image:'
    },
    image: {
      default: null
    },
    canSelectFiles: {
      default: false
    }
  },
  data () {
    return {
      showMediaUploader: false
    }
  },
  computed: {
    media: {
      get: function () {
        return this.image
      },
      set: function (newValue) {
        this.$emit('update:image', newValue)
      }
    }
  },
  methods: {
    toggleMediaUploader () {
      this.showMediaUploader = !this.showMediaUploader
    },
    removeMedia () {
      this.media = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Utils/UploadImage.vue